import * as React from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps
} from 'react-router-dom';

import store from './../store';
import {
  isLoggedInSel,
  activeAccountCountrySel
} from './../store/modules/signin';

interface IPrivateRouteProps extends RouteProps {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}
type RenderComponent = (props: RouteComponentProps<any>) => React.ReactNode;

export class PrivateRoute extends Route<IPrivateRouteProps> {
  public render() {
    const state = store.getState();
    const { component: Component, ...rest }: IPrivateRouteProps = this.props;
    const renderComponent: RenderComponent = props => {
      return isLoggedInSel(state) ? (
        (window.location.href.toString().includes('/ca/') &&
          activeAccountCountrySel(state) === 'US') ||
        (window.location.href.toString().includes('/us/') &&
          activeAccountCountrySel(state) === 'CA') ? (
          <Redirect to="/login" />
        ) : (
          <Component {...props} />
        )
      ) : (
        <Redirect to="/login" />
      );
    };

    return <Route {...rest} render={renderComponent} />;
  }
}

export default PrivateRoute;
